export const ANIMATION = {
  base: {
    x: 0,
    y: 0,
    scale: 1,
    opacity: 1,
    transition: { duration: 3, delay: 0 },
  },

  parentVariants: {
    open: {
      transition: { staggerChildren: 0.07, delayChildren: 0.2 },
    },
    closed: {
      transition: { staggerChildren: 0.05, staggerDirection: -1 },
    },
  },

  childVariants: {
    open: {
      y: 0,
      opacity: 1,
      transition: {
        y: { stiffness: 1000, velocity: -100 },
      },
    },
    closed: {
      y: 50,
      opacity: 0,
      transition: {
        y: { stiffness: 1000 },
      },
    },
  },
}
